var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25623_532068)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3206 15.2554C15.1701 15.4455 14.9483 15.5485 14.7026 15.5485H1.29735C1.05967 15.5485 0.82991 15.4455 0.679378 15.2554C0.520923 15.0652 0.465463 14.8196 0.520923 14.5819L0.821987 13.1875C0.909137 12.8231 1.23397 12.5537 1.60634 12.5537H14.3937C14.766 12.5537 15.0909 12.8231 15.178 13.1875L15.4791 14.5819C15.5345 14.8196 15.4791 15.0652 15.3206 15.2554Z",
    opacity: 0.2,
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4697 5.66069V6.12021C15.4697 6.65897 15.0338 7.09472 14.4951 7.09472H1.50184C0.963095 7.09472 0.527344 6.65897 0.527344 6.12021V5.66069C0.527344 5.32794 0.693721 5.02687 0.97894 4.84465L7.46763 0.653517C7.79246 0.447526 8.20444 0.447526 8.52927 0.66144L15.0259 4.84465C15.3032 5.01895 15.4697 5.32794 15.4697 5.66069Z",
    opacity: 0.2,
    fill: "#1080FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7664 12.553H13.9549V7.09424H12.7664V12.553ZM9.19329 12.553H10.3817V7.09424H9.19329V12.553ZM5.61222 12.553H6.80062V7.09424H5.61222V12.553ZM2.03906 12.553H3.22747V7.09424H2.03906V12.553Z",
    opacity: 0.8,
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0278 4.87157C7.6998 4.87157 7.43359 4.60537 7.43359 4.27737C7.43359 3.94936 7.6998 3.6792 8.0278 3.6792C8.3558 3.6792 8.62201 3.94144 8.62201 4.26944V4.27737C8.62201 4.60537 8.3558 4.87157 8.0278 4.87157Z",
    opacity: 0.8,
    fill: "#1080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25623_532068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.060c7e62.svg";
export { ForwardRef as ReactComponent };